<template>
    <main class="max-w-5xl m-5 mb-10 w-full p-1">
        <ReadOnlyCIE v-if="!isAdmin" :is-emitter="isEmitter" />
        <CIEForm ref="form" v-else />
        <CIEAttachments :isAdmin="isAdmin" :allowNewAttachment="isAdmin || isEmitter"></CIEAttachments>
        <div>
            <app-button
                v-if="
                    isAdmin &&
                    cie.versions &&
                    cie.versions.length > 1 &&
                    cie.versions[cie.versions.length - 1].id !== cie.id
                "
                size="mini"
                icon="icon-trash-can-outline"
                variant="danger"
                @click="removeCie()"
                :label="$t('commons.removeThisVersion')"
                class="m-2"
            />
        </div>
        <app-quick-actions :options="quickActions" @choose="$event.run()"></app-quick-actions>
    </main>
</template>

<script>
import { updateBreadCrumbs } from '@/state/state';
import AppQuickActions from '../../components/appQuickActions/AppQuickActions';
import { confirm } from '@/features/dialogs/dialogs.service';
import { getProject } from '@/features/projects/projects.service';
import AppButton from '@/components/appButton/AppButton.vue';
import { combineLatest } from 'rxjs';
import ReadOnlyCIE from '@/features/cie/ReadOnlyCIE.vue';
import CIEForm from '@/features/cie/CIEForm.vue';
import { getCie, removeCie } from '@/features/cie/CIE.service';
import CIEAttachments from '@/features/cie/CIEAttachments.vue';

export default {
    components: {
        CIEAttachments,
        CIEForm,
        ReadOnlyCIE,
        AppButton,
        AppQuickActions,
    },

    async created() {
        this.init();
    },
    watch: {
        $route: function () {
            this.init();
        },
    },
    methods: {
        init() {
            this.subscriptions = [
                combineLatest([
                    getProject(this.$route.params.projectId),
                    getCie(this.$route.params.projectId, this.$route.params.cieId),
                ]).subscribe(([project, cie]) => {
                    this.project = project;
                    this.cie = cie;
                    this.isLastVersion =
                        cie.versions.findIndex((version) => version.id === this.$route.params.cieId) === 0;

                    this.isAdmin = project.me.allowedFeatures.includes('project_amendments');
                    this.isEmitter = project.me.bundleIds.includes(cie.bundleId);
                    updateBreadCrumbs({
                        cieName: cie.object,
                    });
                }),
            ];
        },
        async removeCie() {
            if (await confirm(this.$t('commons.confirmMessage'))) {
                removeCie(this.$route.params.projectId, this.$route.params.cieId);
                if (this.cie.versions.length > 1) {
                    this.$router.push({
                        name: this.$route.name,
                        params: {
                            projectId: this.$route.params.projectId,
                            cieId: this.cie.versions[1].id,
                        },
                    });
                } else {
                    this.$router.push({
                        name: this.$route.meta.parentName,
                        params: {
                            projectId: this.$route.params.projectId,
                        },
                    });
                }
            }
        },
    },
    data() {
        return {
            subscriptions: [],
            cie: { versions: [] },
            project: null,
            isAdmin: false,
            isEmitter: false,
            isLastVersion: false,
        };
    },
    computed: {
        quickActions() {
            if (!this.isAdmin) {
                return [];
            }
            const defaultOptions = [
                {
                    name: this.$t('cie.newCie'),
                    run: () => this.$refs.form.createNew(),
                },
                {
                    name: this.$t('commons.newVersion'),
                    run: () => this.$refs.form.onNewVersion(),
                },
            ];
            if (this.cie.versions && this.cie.versions.length > 0 && this.cie.versions[0].id === this.cie.id) {
                defaultOptions.push({
                    name:
                        this.cie.versions.length === 1
                            ? this.$t('commons.removeThisGroup')
                            : this.$t('commons.removeThisVersion'),
                    run: async () => this.removeCie(),
                });
            }
            return defaultOptions;
        },
    },
};
</script>
